import { render } from "./IconRunningMan.vue?vue&type=template&id=84678dda"
import script from "./IconRunningMan.vue?vue&type=script&lang=js"
export * from "./IconRunningMan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__